import { getTours } from '@/api/endpoints';
import { AccountDB } from '@/db/repositories';
import { isDBEntryStale, setDBUpdatedNow } from '@/db/helpers/dbMetadata';
import { onlineStatus } from '@/utils';

export const syncAccountData = async ({ forceUpdate } = { forceUpdate: false }) => {
  const isOnline = onlineStatus.get();
  if (!isOnline) return;

  const isStale = await isDBEntryStale('getTours');
  if (!isStale && !forceUpdate) return;

  try {
    const accounts = await getTours();
    await AccountDB.bulkAdd(accounts);
    await setDBUpdatedNow('getTours');
  } catch (error) {
    console.error('Failed to sync getTours from API:', error);
    // TODO: Save error to ErrorLogRepo
  }
};

export const getAccountData = async () => {
  await syncAccountData();

  const accounts = await AccountDB.list();
  return accounts;
};
